// extracted by mini-css-extract-plugin
export default {"form":"NewTaskCreater_form__--gAW","input":"NewTaskCreater_input__G12FP","addButton":"NewTaskCreater_addButton__MSHvV"};